import CentredSpinner from "../../../lib/core_components/CentredSpinner";
import { useBidResponse } from "../../../lib/hooks/api/bid/bid_responses/useBidResponse";
import { Flex } from "../../../styles/utility-components";
import EmptyState from "../../ui/empty_state/EmptyState";
import { BidResponseContent } from "./BidResponseContent";

interface BidResponsePageProps {
  bidResponseId: string | undefined;
}

export function BidResponsePage({ bidResponseId }: BidResponsePageProps) {
  const {
    data: bidResponse,
    isLoading: isLoadingBidResponse,
    isError: isBidResponseError,
  } = useBidResponse({ id: bidResponseId ?? "" }, { enabled: !!bidResponseId });

  if (isLoadingBidResponse) {
    return <CentredSpinner />;
  }

  if (isBidResponseError) {
    return (
      <Flex flexGrow={1} alignItems="center">
        <EmptyState
          type="loadError"
          heading="Sorry something has gone wrong loading this response"
          description="If this error persists please contact support"
          width="100%"
          size="large"
        />
      </Flex>
    );
  }

  if (!bidResponse) {
    return (
      <Flex flexGrow={1} alignItems="center">
        <EmptyState
          type="loadError"
          heading="Bid response not found"
          description="The bid response you're looking for doesn't exist"
          width="100%"
          size="large"
        />
      </Flex>
    );
  }

  return <BidResponseContent bidResponse={bidResponse} />;
}
